import { AccountInfo, AuthError } from '@azure/msal-browser';
import { createActionGroup, props } from '@ngrx/store';

import { AuthenticationStatus } from '../state/msal-auth.state';
import { CustomAuthErrorCodes } from '../../config/constants';

export const MsalAuthActions = createActionGroup({
  source: 'MsalAuth',
  events: {
    'Set Authentication State': props<{
      status: AuthenticationStatus;
      accountInfo: AccountInfo | null;
    }>(),
    'Handle Auth Error': props<{
      error: AuthError | { message: string; errorCode?: string };
    }>(),
    'Set Error Code': props<{
      errorCode: CustomAuthErrorCodes;
    }>(),
  },
});
